export * from './betting-style-image';